import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { useAtom } from 'jotai';
import { Controller, useForm } from 'react-hook-form';

import { Switch } from '@restworld/ui-ds';
import { useEmployerUserContactData } from '@restworld/feature-authentication';
import { useEmployerManageNotificationsMutation } from './use-employer-user-information';
import { modalManageNotificationsVisibleAtom } from '.';
import { ModalToggleWrapper } from './form-modal-wrapper';

export const ManageNotificationsModal = () => {
  const { t } = useTranslation('user-settings');
  const router = useRouter();
  const methods = useForm<{
    weekly_spontaneous_applications_email: boolean;
    showcase_monthly_performance_email: boolean;
  }>();
  const employerUserInformation = useEmployerUserContactData();
  const [modalVisible, setModalVisible] = useAtom(modalManageNotificationsVisibleAtom);
  const { mutate, isPending } = useEmployerManageNotificationsMutation();

  // Apri il modale se l'URL contiene ?manage_notifications=1
  React.useEffect(() => {
    if (router && router.query && router.query.manage_notifications === '1') {
      setModalVisible(true);
    }
  }, [router, setModalVisible]);

  React.useEffect(() => {
    if (
      typeof employerUserInformation?.weekly_spontaneous_applications_email === 'boolean' ||
      typeof employerUserInformation?.showcase_monthly_performance_email === 'boolean'
    ) {
      methods.reset({
        weekly_spontaneous_applications_email: employerUserInformation.weekly_spontaneous_applications_email ?? false,
        showcase_monthly_performance_email: employerUserInformation.showcase_monthly_performance_email ?? false,
      });
    }
  }, [employerUserInformation, methods]);

  const onSubmit = (data: {
    weekly_spontaneous_applications_email: boolean;
    showcase_monthly_performance_email: boolean;
  }) => {
    mutate({
      user_id: employerUserInformation?.user_id,
      weekly_spontaneous_applications_email: data.weekly_spontaneous_applications_email,
      showcase_monthly_performance_email: data.showcase_monthly_performance_email,
    });
  };

  return (
    <ModalToggleWrapper
      modalVisible={modalVisible}
      onModalClose={() => setModalVisible(false)}
      onSubmitHandler={methods.handleSubmit(onSubmit)}
      loading={isPending}
      title={t('notification_title')}
      onCancelHandlerProps={{
        onClick: () => setModalVisible(false),
        title: t('cancel'),
      }}
    >
      <Controller
        name="weekly_spontaneous_applications_email"
        control={methods.control}
        render={({ field }) => (
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span>{t('weekly_spontaneous_applications_email_label')}</span>
            <Switch
              checked={field.value}
              onChange={field.onChange}
              srOnlyLabel={t('weekly_spontaneous_applications_email_label')}
            />
          </div>
        )}
      />
      <Controller
        name="showcase_monthly_performance_email"
        control={methods.control}
        render={({ field }) => (
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span>{t('showcase_monthly_performance_email_label')}</span>
            <Switch
              checked={field.value}
              onChange={field.onChange}
              srOnlyLabel={t('showcase_monthly_performance_email_label')}
            />
          </div>
        )}
      />
    </ModalToggleWrapper>
  );
};
